import { PayPalButtonsComponent, PayPalButtonsComponentOptions } from '@paypal/paypal-js/types/components/buttons';
import type { Steps } from 'config/constants';
import type { CheckoutStore } from 'reduxStore/types';
import type { CheckoutParentMessageTypes } from 'services/checkoutParent/constants';
import type { CheckoutParent } from 'services/checkoutParent/types';

/* eslint-disable no-use-before-define, @typescript-eslint/no-explicit-any */
export type JSONKey = string | number;
export type JSONScaler = string | number | boolean | undefined | null;
export type JSONObject = { [Key in JSONKey]: JSONScaler | JSONObject | JSONCollection };
export type JSONCollection = (JSONScaler | JSONObject | JSONCollection)[];
export type JSONEncodable = JSONObject | JSONCollection | JSONScaler;
export interface AnyObject { [key: string]: any }

export type Nullable<T> = { [K in keyof T]: T[K] | null };
export type DeepNullable<T> = {
  [K in keyof T]: DeepNullable<T[K]> | null;
};

export type PaypalSDKv5 = {
  Buttons: (options?: PayPalButtonsComponentOptions) => PayPalButtonsComponent;
  FUNDING: {
    PAYPAL: 'paypal';
    PAYLATER: 'paylater';
    CARD: 'card';
  };
  version: string;
};

export type PaypalSDKv4 = {
  Button: {
    render: (paypalButtonsConfig: any, selector: string) => void;
  };
  FUNDING: {
    PAYPAL: 'paypal';
    PAYLATER: 'paylater';
    CARD: 'card';
  };
};

export type PaypalSDK = PaypalSDKv4 & PaypalSDKv5;

export enum PaypalEnvs {
  Staging = 'paypal-staging',
  Production = 'production',
  Sandbox = 'sandbox',
}

export const isPaypalEnvProd = (paypalEnv: PaypalEnvs): paypalEnv is PaypalEnvs.Production => paypalEnv === PaypalEnvs.Production;
export const isPaypalEnvSandbox = (paypalEnv: PaypalEnvs): paypalEnv is PaypalEnvs.Sandbox => paypalEnv === PaypalEnvs.Sandbox;
export const isPaypalEnvStaging = (paypalEnv: PaypalEnvs): paypalEnv is PaypalEnvs.Staging => paypalEnv === PaypalEnvs.Staging;

export interface CheckoutAppWindow extends Window {
  devModules: {
    actions: any;
    checkoutApi: any;
    checkoutParent: CheckoutParent;
    CheckoutParentMessageTypes: typeof CheckoutParentMessageTypes;
    honeyApi: any;
    ls: any;
    logger: any;
    services: any;
    reduxStore: CheckoutStore | null;
    Steps: typeof Steps;
  };
  google: typeof google;
  paypal_honey: PaypalSDKv5;
  PAYPAL: {
    analytics: {
      logActivity: (data: JSONObject) => void;
    };
  };
}

/* since libs can throw anything including errors without required "name" property we
   just want to enforce that the error at least has a message property since that is
   what we want to read most of the time: */
export type ErrorWithMessage = {
  message: string;
};
